const breakIntoParagraphs = (text: string): string[] => {
  return text
    ?.split('\n')
    ?.filter((paragraph) => paragraph?.trim()?.length > 0);
};

export default breakIntoParagraphs;
